<template>
    <ai-home-component :meta="meta" />
</template>

<script>
export default {
    name: 'ai-home-view-el',
    data() {
        return {
            meta: {},
        };
    },
};
</script>
